import { render, staticRenderFns } from "./valorespago.vue?vue&type=template&id=6ce1c80e"
import script from "./valorespago.vue?vue&type=script&lang=js"
export * from "./valorespago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports